import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { PlusIcon } from "@/components/icons/plus-icon";
import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { getSafeAreaBottom } from "@/utils/safe-area-bottom";
import { memo, useState } from "react";
import { AddMealToModal } from "../add-meal-to-modal";

interface MealDetailAddMealFabProps {
  mealData: Meal;
  mealTime: MealTime;
  notLikeable?: boolean;
}

export const MealDetailAddMealFab = memo(function MealDetailAddMealFab({
  mealData,
  mealTime,
  notLikeable,
}: MealDetailAddMealFabProps) {
  const [isAddMealToModalOpen, setIsAddMealToModalOpen] = useState(false);

  return (
    <>
      <div className="fixed right-4 bottom-0 z-[60]" style={{ marginBottom: getSafeAreaBottom() }}>
        <FilledButton
          type="button"
          color="primary"
          aria-label="Add meal to"
          onClick={() => setIsAddMealToModalOpen(true)}
          className="shadow-card !m-0 !size-[52px] !min-h-[52px] !min-w-[52px] !flex-none !rounded-full !p-0 transition-transform duration-200 ease-out active:scale-95"
        >
          <PlusIcon className="h-6 w-6 fill-white" />
        </FilledButton>
      </div>

      <AddMealToModal
        isOpen={isAddMealToModalOpen}
        onDismiss={() => setIsAddMealToModalOpen(false)}
        meal={mealData}
        mealTime={mealTime}
        notLikeable={notLikeable}
      />
    </>
  );
});
